module.exports = __webpack_public_path__ + "static/largeIntro-83add769195b4b601e82776d0d15c3ca.mp4";